<template>
  <v-layout row wrap>
    <v-flex xs12>
      <h2>Welcome to CareShip 2.0!</h2>
    </v-flex>

    <v-flex xs6 sm6 md4 lg6>
      <v-card>
        <v-card-title primary-title>
          <h3>
            Caregiver Profiles:
          </h3>
        </v-card-title>

        <div class="button-groups">
          <CSButton
            id="button_home_caregiverProfile"
            :onClick="() => caregiverProfile(1)"
            text="Caregiver Profile 1"
          />

          <CSButton
            id="button_home_caregiverProfile"
            :onClick="() => caregiverProfile(2)"
            text="Caregiver Profile 2"
          />

          <CSButton
            id="button_home_caregiverProfile"
            :onClick="() => caregiverProfile(3)"
            text="Caregiver Profile 3"
          />

          <CSButton
            id="button_home_caregiverProfile"
            :onClick="() => caregiverProfile(4)"
            text="Caregiver 404"
          />
        </div>
      </v-card>
    </v-flex>

    <v-flex xs6 sm6 md4 lg6>
      <v-card>
        <v-card-title primary-title>
          <h3>
            Pages:
          </h3>
        </v-card-title>

        <div class="button-groups">
          <CSButton id="button_home_login" :onClick="login" text="Login" />

          <CSButton id="button_home_logout" :onClick="logout" text="Logout" />

          <CSButton
            id="button_home_forgotPassword"
            :onClick="forgotPassword"
            text="Forgot Password"
          />

          <CSButton
            id="button_home_resetPassword"
            :onClick="resetPassword"
            text="Reset password"
          />

          <CSButton
            id="button_home_confirmation"
            :onClick="() => confirmation()"
            text="Verification page"
          />
        </div>
      </v-card>
    </v-flex>

    <v-flex xs12 sm6 md4 lg6>
      <v-card>
        <v-card-title primary-title>
          <h3>
            Booking Prototype:
          </h3>
        </v-card-title>

        <div class="button-groups">
          <CSButton
            id="button_home_bookingsFunnel"
            :onClick="bookingFunnel"
            text="Bookings Funnel"
          />

          <CSButton
            id="button_home_bookingsThankYou"
            :onClick="bookingThankYou"
            text="Bookings Thank You"
          />

          <CSButton
            id="button_home_bookingsFunnelSteps"
            :onClick="bookingFunnelSteps"
            text="Bookings Funnel Steps"
          />

          <CSButton
            id="button_home_bookingsConfimation"
            :onClick="bookingConfirmation"
            text="Confirmation"
          />

          <CSButton
            id="button_home_bookingsConfimationEmail"
            :onClick="bookingConfirmationEmail"
            text="Confirmation - Unverified Email"
          />
        </div>
      </v-card>
    </v-flex>

    <v-flex xs12 sm6 md4 lg6>
      <v-card>
        <v-card-title primary-title>
          <h3>
            Dashboard:
          </h3>
        </v-card-title>

        <div class="button-groups">
          <CSButton
            id="button_home_MyCaregivers"
            :onClick="dashboardMyCaregivers"
            text="My Caregivers"
          />

          <CSButton
            id="button_home_MyFamily"
            to="meine-familie"
            text="My Family Overview"
          />
        </div>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import CSButton from '@/components/atoms/button/CSButton.vue'

export default {
  name: 'CSHome',
  components: {
    CSButton,
  },
  methods: {
    resetPassword() {
      this.$router.push('/reset-password')
    },
    caregiverProfile(id = 1) {
      this.$router.push(`/caregiver/${id}`)
    },
    translate(key) {
      return this.$store.getters.translation(key)
    },
    logout() {
      this.$router.push('/logout')
    },
    forgotPassword() {
      this.$router.push('/forgot-password')
    },
    login() {
      this.$router.push('/login')
    },
    bookingFunnel() {
      this.$router.push('/anfrage')
    },
    bookingFunnelSteps() {
      this.$router.push('/buchung/services')
    },
    bookingThankYou() {
      this.$router.push('/vielen-dank')
    },
    confirmation(token = '') {
      this.$router.push(`/confirmation/${token}`)
    },
    bookingConfirmation() {
      this.$router.push('/erfolgreiche-buchung')
    },
    bookingConfirmationEmail() {
      this.$router.push('/erfolgreiche-buchung-unverifiziert')
    },
    dashboardMyCaregivers() {
      this.$router.push('/meine-alltagshelfer')
    },
  },
}
</script>
